import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "react-image-crop/dist/ReactCrop.css";

function ImageCrop({ imageSrc, detectionData, height, width, projectType }) {
  const canvasRef = React.createRef();
  useEffect(() => {
    let canvas = ReactDOM.findDOMNode(canvasRef.current);
    const ctx = canvas.getContext("2d");

    var imageFile = new Image();
    imageFile.src = imageSrc;

    if (projectType === "GROUND") {
      cropGroundImage(imageFile, canvas, ctx);
    }

    if (projectType === "AERIAL") {
      cropAerialImage(imageFile, canvas, ctx);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function cropGroundImage(imageFile, canvas, ctx) {
    imageFile.onload = function () {
      const width_bb = detectionData.x2 - detectionData.x1;
      const height_bb = detectionData.y4 - detectionData.y1;

      let imageRatio =
        (height_bb * imageFile.height) / (width_bb * imageFile.width);
      canvas.height = imageRatio * canvas.width;

      if (height && width) {
        canvas.height = height;
        canvas.width = width;
      }

      try {
        ctx.drawImage(
          imageFile,
          detectionData.x1 * imageFile.width, // sourceX
          detectionData.y2 * imageFile.height, // sourceY
          width_bb * imageFile.width, //sourceWidth
          height_bb * imageFile.height, // sourceHeight
          0, // destinationX
          0, // destinationY
          canvas.width, // destinationWidth
          canvas.height // destinationHeight
        );
      } catch (e) {
        console.log(e);
      }
    };
  }

  function cropAerialImage(imageFile, canvas, ctx) {
    imageFile.onload = function () {
      let imageRatio =
        (detectionData.height_bb * imageFile.height) /
        (detectionData.width_bb * imageFile.width);
      canvas.height = imageRatio * canvas.width;

      if (height && width) {
        canvas.height = height;
        canvas.width = width;
      }

      ctx.drawImage(
        imageFile,
        detectionData.xcenter_bb * imageFile.width -
          (detectionData.width_bb * imageFile.width) / 2, // sourceX
        detectionData.ycenter_bb * imageFile.height -
          (detectionData.height_bb * imageFile.height) / 2, // sourceY
        detectionData.width_bb * imageFile.width, //sourceWidth
        detectionData.height_bb * imageFile.height, // sourceHeight
        0, // destinationX
        0, // destinationY
        canvas.width, // destinationWidth
        canvas.height // destinationHeight
      );
    };
  }

  return (
    <canvas
      ref={canvasRef}
      style={{
        border: "2px solid #000",
        margin: "auto",
        width: "100%",
        backgroundColor: "black",
      }}
    ></canvas>
  );
}

export default ImageCrop;
